import { Directive, Input, ViewContainerRef, Type, OnChanges, ComponentRef, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appDynamicComponent]',
})
export class DynamicComponentDirective implements OnChanges {
  @Input('appDynamicComponent') appDynamicComponent!: () => Promise<Type<any>>; // Input the component you want to load dynamically
  @Input() inputProps: any = {};
  private componentRef?: ComponentRef<any>;

  constructor(private viewContainerRef: ViewContainerRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.appDynamicComponent && this.appDynamicComponent) {
      this.loadComponent();
    }
  }

  private async loadComponent(): Promise<any> {
    const loadedComponent = await this.appDynamicComponent();
    if (this.componentRef) {
      this.componentRef.destroy();
    }
    this.componentRef = this.viewContainerRef.createComponent(loadedComponent);
    // Set the @Input properties on the dynamically created component
    for (const prop in this.inputProps) {
      if (this.inputProps.hasOwnProperty(prop)) {
        this.componentRef.instance[prop] = this.inputProps[prop];
      }
    }
  }
}
